module.exports = __webpack_public_path__ + "static/US1_1P traditional-be2e71ffc13a2f5053721cf9c1818ae3.png";